<div class="container" *ngIf="showMenu">
  <ng-template #tipContent let-greeting="greeting">{{greeting}}</ng-template>
  <ng-template
    #itemTemplate
    let-item="item"
    let-onCollapseExpand="onCollapseExpand"
    let-onCheckedChange="onCheckedChange"
  >
    <div class="form-inline row-item">
      <i
        *ngIf="item.children"
        class="mr-1"
        (click)="onCollapseExpand()"
        aria-hidden="true"
        [ngSwitch]="item.collapsed"
      >
        <svg
          *ngSwitchCase="true"
          width="0.8rem"
          height="0.8rem"
          viewBox="0 0 16 16"
          class="bi bi-caret-right-fill"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.14 8.753l-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
          />
        </svg>
        <svg
          *ngSwitchCase="false"
          width="0.8rem"
          height="0.8rem"
          viewBox="0 0 16 16"
          class="bi bi-caret-down-fill"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
          />
        </svg>
      </i>
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="item.checked"
          (ngModelChange)="onCheckedChange(); openSlider(item)"
          [disabled]="item.disabled"
          [indeterminate]="item.indeterminate"
        />
        <label
          class="form-check-label"
          (click)="item.checked = !item.checked; onCheckedChange(); openSlider(item)"
        >
          {{ item.text }}
        </label>

        <label class="form-check-label ml-2">
          <i aria-hidden="true" class="cursor-pointer" >
            <img
              class="icon-info"
              *ngIf="!item.children || item.children.length === 0"
              src="assets/img/info-svgrepo-com.svg"
              [ngbTooltip]="tipContent"
              triggers="manual"
              #t1="ngbTooltip"
              (click)="openTooltip(t1, getTextTooltip(item))"
            />
          </i>
        </label>
      </div>
    </div>
  </ng-template>
  <div class="side-bar-content">
    <nav class="search-content">
      <ion-grid>
        <ion-row (click)="toggleSearch()" class="cursor-pointer">
          <ion-col>BUSCADOR</ion-col>
          <ion-col>
            <div class="close-button">
              <span *ngIf="openSearch"
                ><ion-icon name="chevron-up-outline"></ion-icon
              ></span>
              <span *ngIf="!openSearch"
                ><ion-icon name="chevron-down-outline"></ion-icon
              ></span>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div *ngIf="openSearch">
        <app-search (enterEvent)="performSearch($event)"></app-search>
        <div *ngIf="this.searchList" class="search-scroll">
          <div *ngIf="this.searchList.results.length <= 0" class="mt-2">
            No hay datos con está busqueda
          </div>
          <div *ngFor="let well of this.searchList.results | groupBy : 'type'">
            <ion-accordion-group [multiple]="true" [value]="['DMU', 'FIELD']">
              <ion-accordion [value]="well.key">
                <ion-item slot="header" color="primary">
                  <ion-label>{{ well.key }}</ion-label>
                </ion-item>
                <div slot="content" class="accordion-content" class="list-dmu">
                  <div *ngFor="let item of well.value" class="accordion-item">
                    <ion-item
                      class="item-background-color"
                      (click)="
                        setCenterMap(
                          item.position.coordinates[0],
                          item.position.coordinates[1],
                          item.type,
                          item.name
                        )
                      "
                    >
                      <ion-label>{{ item.name }}</ion-label>
                    </ion-item>
                  </div>
                </div>
              </ion-accordion>
            </ion-accordion-group>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <nav class="side-bar-content">
    <ion-grid>
      <ion-row (click)="toggleDate()" class="cursor-pointer">
        <ion-col>DATOS DISPONIBLES</ion-col>
        <ion-col>
          <div class="close-button">
            <span *ngIf="openDate"
              ><ion-icon name="chevron-up-outline"></ion-icon
            ></span>
            <span *ngIf="!openDate"
              ><ion-icon name="chevron-down-outline"></ion-icon
            ></span>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div *ngIf="openDate">
      <ngx-treeview
        [config]="config"
        [items]="items"
        (selectedChange)="valores = $event"
        [itemTemplate]="itemTemplate"
      >
      </ngx-treeview>
      <ion-button color="secondary" (click)="selectedGraph()">
        Aplicar
      </ion-button>
      <ion-button color="danger" (click)="cleanMap()">Limpiar</ion-button>
      <ion-button id="open-modal" color="secondary" [hidden]="!existCompare" >Comparar</ion-button>
      <ion-button color="danger" (click)="removeCompare()" [hidden]="!showRemoveCompare">Limpiar seleccion</ion-button>
     <!--  <ion-button color="secondary" (click)="removeCompare()">
        Comparación
      </ion-button> -->
    </div>
  </nav>    
</div>

<ion-toast
  class="custom-toast"
  [isOpen]="isOpen"
  (didDismiss)="isOpen = false"
  [duration]="5000"
  [color]="'danger'"
  [position]="'top'"
  [message]="'Cantidad de capas excedida, seleccione maximo 30.'"
></ion-toast>

<ion-modal id="compare-modal" #modal backdropDismiss="false" trigger="open-modal">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Datos comparativos</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="modal.dismiss()">X</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item *ngFor="let cmp of cmpList">
            <ion-checkbox labelPlacement="end" justify="start" (ionChange)="checkCompare(cmp, $event)" color="primary" [checked]="valoresComp.includes(cmp?.id)">{{cmp?.name || 'N/A'}}</ion-checkbox>
        </ion-item>
      </ion-list>
      <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
    <ion-footer>
      <div id="calendar-content" class="map-date-content">
        <app-range-slider-date *ngIf="timeRangeA"
          (maxDateEvent)="setRangeDate($event)"
          (minDateEvent)="setRangeDate($event, 'start')"
          [isRange]="true"
          [name]="'range-2'"
          [id]="'range-map'"
          [minValue]="minValueRange"
          [popoverActive]="true"
        ></app-range-slider-date>
        <app-range-slider-date *ngIf="timeMomentA"
          (maxDateEvent)="setTimeMomentDate($event)"
          (minDateEvent)="setTimeMomentDate($event, 'start')"
          [isRange]="false"
          [id]="'range-map-2'"
          [popoverActive]="true"
          [minValue]="minValue"
          [colorIcon]="'#173d51'"
        ></app-range-slider-date>
      </div>
      <ion-button color="secondary" (click)="SelectedCompare(); modal.dismiss()">
        Aplicar
      </ion-button>      
    </ion-footer>
  </ng-template>
</ion-modal>
